// extracted by mini-css-extract-plugin
module.exports = {"signButton":"SignInButton_signButton__2YoZY","gameMode":"SignInButton_gameMode__3_WCK","text":"SignInButton_text__ckQDn"};